export const INTRO_PRICING_KEY = 'IntroPricing';
export const INTRO_PRICING_DISCOUNT_KEY = 'IntroPricingDiscount';
export const TRUE = 'True';
export const MONTHLY = 2;
